var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper-action" }, [
    _c(
      "div",
      {
        staticClass: "title text-success",
        on: {
          click: function($event) {
            return _vm.setPosSection("queues")
          }
        }
      },
      [
        _c("i", {
          staticClass: "fas fa-check",
          staticStyle: { "margin-right": "3px" }
        }),
        _vm._v("\n    " + _vm._s(_vm.getTextTitle) + "\n  ")
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "add-btn", on: { click: _vm.addPosNextQueue } }, [
      _c("i", { staticClass: "fas fa-plus" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc2d9b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cc2d9b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/QueueButton.vue
// module id = null
// module chunks = 